export { default } from './global';

//# sourceMappingURL=index.js.map